import { get } from 'lodash';
import { songsServices } from '../services';
import { _showAlert } from '../utils';
import axios from '../axios';

export const postSong = async (payload) => {
  try {
    const res = await songsServices.postSong(payload);
    return get(res, 'data', null);
  } catch (error) {
    // Handle error
    return null;
  }
};

export const getSongUploadUrl = async (payload) => {
  try {
    const res = await songsServices.getSongUploadUrl(payload);
    return get(res, 'data', null);
  } catch (error) {
    return null;
  }
};

export const fetchAllSongs = async (payload) => {
  try {
    const res = await songsServices.fetchAllSongs(payload);
    _showAlert('Songs fetched successfully', 'success');
    return get(res, 'data.data', []);
  } catch (error) {
    _showAlert('Something went wrong', 'error');
    // Handle error
    return [];
  }
};

export const deleteSong = async (id) => {
  try {
    const res = await songsServices.deleteSong(id);
    return get(res, 'data.data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const updateSong = async (id, payload) => {
  try {
    await songsServices.updateSong(id, payload);
    _showAlert('Song updated successfully', 'success');
    return true;
  } catch (error) {
    // Handle error
    _showAlert('Something went wrong', 'error');
    return false;
  }
};

export const fetchSongById = async (id) => {
  try {
    const res = await songsServices.fetchSongById(id);
    _showAlert('Songs Details fetched successfully', 'success');
    return get(res, 'data.data', []);
  } catch (error) {
    // Handle error
    return [];
  }
};

export const uploadAvatar = async (id, file) => {
  try {
    // Step 1: Get Signed URL
    const signedUrlRes = await songsServices.getSongImageUploadUrl(id, {
      filename: file.name,
      mimetype: file.type,
    });

    const signedUrlData = get(signedUrlRes, 'data.data');
    if (!signedUrlData) {
      _showAlert('Failed to get upload URL', 'error');
      return null;
    }

    const { signed_url, key } = signedUrlData;

    // Step 2: Upload to R2
    const uploadRes = await fetch(signed_url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    if (!uploadRes.ok) {
      _showAlert('Failed to upload image to storage', 'error');
      return null;
    }

    // Step 3: Save Record
    const res = await songsServices.uploadAvatar(id, {
      image_key: key,
    });
    _showAlert('Avatar uploaded successfully', 'success');
    return get(res, 'data.data', []);
  } catch (error) {
    // Handle error
    _showAlert('Something went wrong during upload', 'error');
    return [];
  }
};

export const fetchSongLicence = async (payload) => {
  try {
    // fetch the Authorization token from axios
    const token = axios.defaults.headers.common['Authorization'];
    const response = await fetch(`${process.env.REACT_APP_API_URL}/media/documents`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });
    const blob = await response.blob();
    return blob;
  } catch (error) {
    // Handle error
    return error;
  }
};

